import apiClient from "./apiClient";

export const request = async ({
    method, url, data = {}, params = {}, headers = {}
}: {
    method: import("axios").Method; url: string; data?: any; params?: any; headers?: any
}): Promise<any> => {
    try {
        const response = await apiClient({
            method,
            url,
            data,
            params,
            headers
        })

        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw error.response.data.message;
        } else if (error.request) {
            throw new Error("no response eceived from server");
        } else {
            throw new Error("An error occur while making the request: " + error.message);
        }
    }
}